module.exports = __webpack_public_path__ + "81159cfe4bcee4843db6b365dcde80f4.png";